import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageViewerModalComponent } from '../image-viewer-modal/image-viewer-modal.component';
import { ImageItem } from '../image-list-modal/image-list-modal.component';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.css'],
  standalone: false
})

export class ImageGalleryComponent implements OnInit {

  @Input() images: ImageItem[] = [];
  @Input() size: 'thumb' | 'medium' | 'large' = 'medium';
  @Input() takeFullWidth = false;

  displayImages: ImageItem[] = [];

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
    this.updateDisplayImages();
  }

  private updateDisplayImages(): void {
    if (!this.images?.length) {
      this.displayImages = [];
      return;
    }

    this.displayImages = this.images;
  }

  trackByUrl(index: number, item: ImageItem): string | undefined {
    return item.largeUrl;
  }

  openImageViewer(index: number): void {
    try {
      const modalRef = this.modalService.open(ImageViewerModalComponent, {
        backdrop: true,
        centered: false,
        size: 'xl',
        scrollable: true,
        animation: false,
        windowClass: 'image-viewer-modal fullscreen-modal'
      });
      const image = this.images[index]
      modalRef.componentInstance.imageUrl = image.largeUrl;
      modalRef.componentInstance.imageTitle = image.filename;
      modalRef.componentInstance.images = this.images;
      modalRef.componentInstance.currentIndex = this.getCurrentImageIndex(index);
    } catch (error) {
      console.error('Failed to open image viewer:', error);
    }
  }

  getGridClass(): string {
    return `image-gallery-grid gallery-${this.size}`;
  }

  private getCurrentImageIndex(displayIndex: number): number {
    const actualImage = this.displayImages[displayIndex];
    return this.images.findIndex((img) => img.largeUrl === actualImage.largeUrl);
  }
}